import { apiGet } from '.';
import { CrewSchedule, CrewDayPlan } from '../../../shared/types/crewSchedule';
import { isoDate } from '../../../shared/lib/time';
import { BareSailing } from '../../../shared/types/sailing';
import { BareStaffNotification } from '@go-shared/types/staffNotification';

export async function getCrewSchedules(
  staffTemplateId: string,
  date: Date
): Promise<CrewSchedule[]> {
  let crewSchedule = (await apiGet(`/crew/${staffTemplateId}/schedule/${isoDate(date)}`)) as any;
  return crewSchedule;
}

export async function getCrewDayPlans(staffTemplateId: string, date: Date): Promise<CrewDayPlan[]> {
  let crewDayPlan = (await apiGet(`/crew/${staffTemplateId}/plan/${isoDate(date)}`)) as any;
  return crewDayPlan;
}

export async function getCrewNotifications(staffRoleId: string): Promise<BareStaffNotification[]> {
  const crewNotifications = (await apiGet(`/crew/${staffRoleId}/notification`)) as any;

  return crewNotifications;
}

export async function getCrewSailings(
  staffTemplateId: string,
  since: Date,
  until: Date
): Promise<BareSailing[]> {
  let queryParams = {
    from: isoDate(since),
    to: isoDate(until),
  };

  let bareSailings = await apiGet<BareSailing[]>(`/crew/${staffTemplateId}/sailing`, queryParams);
  bareSailings.forEach(sailing => {
    sailing.days.forEach(day => {
      day.date = new Date(String(day.date));
    });
  });

  return bareSailings;
}
